import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Globals--------------- */
import { Pressable } from "react-native";

/* -----------------UI--------------- */
import { Surface, Text } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { useToggleCommandbar } from "@memorang/command-bar";

import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
/* -----------------Child components--------------- */
import { Box } from "@memorang/ui";
import { useTranslation } from "react-i18next";

export const CommandBar = () => {
	const toggleCommandbar = useToggleCommandbar();
	const theme = useAppTheme();
	const { t } = useTranslation();
	const demoExamId = useDemoExamStore((state) => state.currentExam.id);
	const isProethica = demoExamId === "proethica";
	const { explicitCallTrackCustomEvent } = useAnalytics();
	const placeholderKey = isProethica
		? "commandBar.placeholderProethica"
		: "commandBar.placeholder";

	return (
		<Pressable
			onPress={() => {
				explicitCallTrackCustomEvent({
					eventName: events.commandBarClicked,
				});
				toggleCommandbar();
			}}
			style={{
				//@ts-ignore - web specific property
				cursor: "pointer",
				outline: "none",
			}}
			tabIndex={-1}
			accessible
			accessibilityRole="button"
			accessibilityLabel={t("commandBar.accessibilityLabel")}
			accessibilityHint={t("commandBar.accessibilityHint")}
		>
			<Surface
				style={{
					height: 40,
					width: 360,
					borderRadius: 28,
					borderWidth: 0,
					flexDirection: "row",
					alignItems: "center",
					paddingLeft: 12,
					paddingRight: 16,
					justifyContent: "flex-start",
					gap: 8,
					backgroundColor: theme.colors.surfaceVariant,
				}}
				elevation={0}
			>
				<Box
					style={{
						width: 24,
						height: 24,
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Icon
						color={theme.colors.onSurfaceVariant || "#373837"}
						name="magnify"
						size={20}
						accessibilityRole="image"
						accessibilityLabel={t("commandBar.accessibilityLabel")}
					/>
				</Box>
				<Text
					style={{
						fontFamily: theme.fonts.bodyMedium.fontFamily,
						fontWeight: "400",
						fontSize: 16,
						color: theme.colors.onSurfaceVariant || "#373837",
						flex: 1,
					}}
					numberOfLines={1}
					accessibilityRole="text"
				>
					{t(placeholderKey)}
				</Text>
			</Surface>
		</Pressable>
	);
};
